/**
 * Adds px unit to string meant for CSS, if the string is unitless
 *
 * @param sizeString string meant for CSS
 * @param ignoreNullish whether to immediately return if sizeString is null or undefined
 */
export function sizeStringToCss(sizeString: string, ignoreNullish = false): string {
	if (sizeString === undefined || sizeString === null) {
		if (ignoreNullish) {
			return sizeString;
		} else {
			throw new Error('Size string is null or undefined');
		}
	}

	// If string consists of just numbers
	if (/^[\d.]+$/.test(sizeString)) {
		return sizeString + 'px';
	}
	return sizeString;
}
